import { inject, Injectable } from '@angular/core';
import { SiThemeService } from '@siemens/element-ng/theme';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private siThemeService = inject(SiThemeService);
    private themeSubject = new BehaviorSubject<'light' | 'dark'>(this.getTheme());
    public theme$ = this.themeSubject.asObservable();

    public setTheme(mode: 'light' | 'dark'): void {
        const htmlElement = document.documentElement;
        if (mode === 'dark') {
            htmlElement.classList.add('dark');
            htmlElement.setAttribute('data-mode', 'dark');
        } else {
            htmlElement.classList.remove('dark');
            htmlElement.removeAttribute('data-mode');
        }
        this.siThemeService.applyThemeType(mode);
        this.themeSubject.next(mode);
    }

    public getTheme(): 'light' | 'dark' {
        return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
    }
}
